import { type SVGProps } from 'react'

export function HandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107442)">
        <path
          d="M4.695 7.64v1.801m0-1.8V3.32c0-.597.493-1.08 1.102-1.08.608 0 1.102.483 1.102 1.08M4.695 7.64c0-.596-.493-1.08-1.102-1.08-.608 0-1.102.484-1.102 1.08v1.441c0 2.983 2.467 5.402 5.51 5.402 3.042 0 5.509-2.419 5.509-5.402v-3.6c0-.597-.494-1.08-1.102-1.08-.609 0-1.102.483-1.102 1.08M6.899 3.32v3.96m0-3.96V2.6c0-.597.493-1.08 1.101-1.08.609 0 1.102.483 1.102 1.08v.72m0 0v3.96m0-3.96c0-.597.494-1.08 1.102-1.08.609 0 1.102.483 1.102 1.08v2.16m0 0v1.8"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}
